exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".author[data-v-8384f110]{width:65%;background-color:#f7f8fa;padding-top:40px}.author .author_nav[data-v-8384f110]{overflow:hidden;margin-left:5%;border:1px solid #ccc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8384f110","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/public/home/homeRight.vue
// module id = 657
// module chunks = 0